<div class="receipt-container">
    <div class="receipt-status">
        <i *ngIf="paymentDetails.paid" class="bi bi-check-circle-fill success-icon"></i>
        <i *ngIf="!paymentDetails.paid" class="bi bi-x-circle-fill failed-icon"></i>
        <h2 [ngClass]="{'success-title': paymentDetails.paid, 'failed-title': !paymentDetails.paid}">
            {{ paymentDetails.paid ? 'Payment Successful' : 'Payment Failed' }}
        </h2>
        <p class="status-subtitle">
            {{ paymentDetails.paid ? 'Your payment was successfully received.' : 'There was an issue with your payment. Please try again.' }}
        </p>
    </div>

    <div class="receipt-details">
        <div class="details-row">
            <span class="details-label">Invoice No:</span>
            <span class="details-value">{{ paymentDetails.billId || 'N/A' }}</span>
        </div>
        <div *ngIf="paymentDetails.paid" class="details-row">
            <span class="details-label">Paid At:</span>
            <span class="details-value">{{ paymentDetails.paidAt | date: 'dd MMM yyyy HH:mm:ss' }}</span>
        </div>
        <hr class="styled-hr"/>
        <div class="details-row">
            <span class="details-label">Payment Status:</span>
            <span class="details-value" [ngClass]="{'success': paymentDetails.paid, 'failed': !paymentDetails.paid}">
                {{ paymentDetails.paid ? 'Paid' : 'Unpaid' }}
            </span>
        </div>
    </div>
</div>